import getTableConversationRelation from './getTableConversationRelation';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Returns count of nodes if we are in conversation view, else returns 1
 * @param rowId is the id of item/conversation
 * @param tableViewId is the id of current table view
 * @param listViewType is the current type of list view
 */
export default function getConversationNodeCount(
    rowId: string,
    tableViewId: string,
    listViewType: ReactListViewType
): number {
    const tableConversationRelation = getTableConversationRelation(rowId, tableViewId);
    return listViewType === 0 ? tableConversationRelation.itemIds.length : 1;
}
